"use client";
import {
  MenuItemCheckedContext
} from "../__chunks/QQ7MJHYB.js";
import {
  useCheckboxCheck
} from "../__chunks/W2DLJJIX.js";
import "../__chunks/6XBVQI3K.js";
import "../__chunks/X3ATWMYX.js";
import "../__chunks/KSMDNUGB.js";
import "../__chunks/B4BLW6E7.js";
import "../__chunks/7CRP5UGO.js";
import "../__chunks/SNQAYGW2.js";
import "../__chunks/P3UIANB7.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/menu/menu-item-check.ts
import { useContext } from "react";
var useMenuItemCheck = createHook(
  (_a) => {
    var _b = _a, { store, checked } = _b, props = __objRest(_b, ["store", "checked"]);
    const context = useContext(MenuItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck(__spreadProps(__spreadValues({}, props), { checked }));
    return props;
  }
);
var MenuItemCheck = createComponent((props) => {
  const htmlProps = useMenuItemCheck(props);
  return createElement("span", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuItemCheck.displayName = "MenuItemCheck";
}
export {
  MenuItemCheck,
  useMenuItemCheck
};
